module.exports = __webpack_public_path__ + "static/media/chloe.6a931b89.jpg";